module.exports = __webpack_public_path__ + "static/media/recognition.6d95dbaf.svg";